<div class="white-box p-4 border-radius mt-2" *ngIf="!emptyResponse">
	<sct-custom-table
		[columnsConfig]="columnConfig"
		[data]="tableData"
		[config]="tableConfig"
	></sct-custom-table>
</div>
<div *ngIf="emptyResponse" class="text-center p-4">
	{{'g.no_data_available_for_the_selected_period' | translate}}
</div>
<div class="text-danger" *ngIf="invalidDateRange"><b>{{'g.start_lg_end' | translate}}</b></div>
